import { Button, Divider, Flex, Text } from "@fluentui/react-northstar";

import { PollyDialog } from "./PollyDialog";

type Props = {
  onClose: () => void;
};

const CUSTOM_ANALYTICS_TEXT_PARA_1 =
  "Thank you for utilizing our custom analytics feature. A Polly analyst will be assigned shortly and provide both a spreadsheet and slide deck of your data. This usually takes 2-3 business days until delivery.";
const CUSTOM_ANALYTICS_TEXT_PARA_2 =
  "To enable this, a Polly analyst will require access to the data from this polly and may request additional demographics data to conduct the analysis and generate the required documents. All Polly analysts are security trained and background checked to ensure the highest level of security. Do you consent to this access?";

export const RequestCustomAnalyticsDialog: React.FC<Props> = ({ onClose }) => {
  return (
    <PollyDialog open onCancel={onClose} maxWidth={"500px"}>
      <Flex column gap="gap.medium">
        <Flex column gap="gap.small">
          <Text weight="bold" size="larger" content={"Custom Analytics"} align="center" />
          <Divider />
        </Flex>
        <Flex column gap="gap.medium" style={{ fontSize: "16px", padding: "0px 10px" }}>
          <Text content={CUSTOM_ANALYTICS_TEXT_PARA_1} align="center" />
          <Text content={CUSTOM_ANALYTICS_TEXT_PARA_2} align="center" />
        </Flex>
        <Divider />
        <Flex>
          <Flex.Item push>
            <Flex gap="gap.medium">
              <Button onClick={onClose}>Cancel</Button>
              <Button onClick={onClose} primary>
                Yes
              </Button>
            </Flex>
          </Flex.Item>
        </Flex>
      </Flex>
    </PollyDialog>
  );
};
